var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ContentTable"},[_c('TransitionGroup',{attrs:{"name":"transition-fade"}},_vm._l((_vm.rows),function(block){return _c('ce-content-block',{directives:[{name:"show",rawName:"v-show",value:(block.id),expression:"block.id"}],key:block.id,attrs:{"block":block}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }